const dictionary = {
  uk: {
    messages: {
      alpha: function (n) {
        return "Поле може містити тільки літери."
      },
      'emailMethod': function (n) {
        return "В полі повинна бути адреса електронної пошти."
      },
      numeric: function (n) {
        return "Поле може містить лише цифри."
      },
      'alpha_numeric_symbols': function (n) {
        return "Поле має невірний формат."
      },
      required: function (n) {
        return "Це поле обов'язкове."
      },
      max: function (n, e) {
        return `Поле не може містити більше ${e.length} символів.`
      },
      min: function (n, e) {
        return `Поле повинно містити як мінімум ${e.length} символів.`
      },
      'max_value': function (n, e) {
        return `Значення не повинно перевищувати ${e}.`
      },
      'min_value': function (n, e) {
        return `Значення не повинно бути меншим за ${e}.`
      },
      '_default': function (n) {
        return "Поле має невірний формат."
      },
      'username': function (n) {
        return "Поле має невірний формат."
      },
      'numeric_method': function (n) {
        return "Поле може містить лише цифри."
      },
      phoneNumber: function (n, e) {
        return "Введіть повний номер телефону."
      },
      passwordMethod: function (n, e) {
        return "Введіть більш складний пароль."
      },
      confirmed: function (n, e) {
        return "Значення не збігаються."
      },
    },
  },
  ru: {
    messages: {
      alpha: function (n) {
        return "Поле может содержать только буквы."
      },
      'emailMethod': function (n) {
        return "Поле должно быть действительным электронным адресом."
      },
      numeric: function (n) {
        return "Поле должно быть числом."
      },
      'alpha_numeric_symbols': function (n) {
        return "Поле имеет ошибочный формат."
      },
      required: function (n) {
        return "Это поле обязательное."
      },
      '_default': function (n) {
        return "Поле имеет ошибочный формат."
      },
      'username': function (n) {
        return "Поле имеет ошибочный формат."
      },
      'numeric_method': function (n) {
        return "Поле должно быть числом."
      },
      max: function (n, e) {
        return `Поле не может содержать больше ${e.length} символов.`
      },
      min: function (n, e) {
        return `Поле должно содержать как минимум ${e.length} символов.`
      },
      'max_value': function (n, e) {
        return `Значение не должно превышать ${e}.`
      },
      'min_value': function (n, e) {
        return `Значение не должно быть меньше чем ${e}.`
      },
      phoneNumber: function (n, e) {
        return "Введите полный номер телефона."
      },
      passwordMethod: function (n, e) {
        return "Введите более сложный пароль."
      },
      confirmed: function (n, e) {
        return "Значения не совпадают."
      },
    },
  },
  en: {
    messages: {
      alpha: function (n) {
        return "The field can contain only letters."
      },
      alpha_spaces: function (n) {
        return "The field can contain only letters."
      },
      'email': function (n) {
        return "The field must be a valid email address."
      },
      numeric: function (n) {
        return "The field must be a number."
      },
      'alpha_numeric_symbols': function (n) {
        return "The field has an invalid format."
      },
      required: function (n) {
        return "This field is required."
      },
      '_default': function (n) {
        return "The field has an invalid format."
      },
      'username': function (n) {
        return "The field has an invalid format."
      },
      'numeric_method': function (n) {
        return "The field must be a number."
      },
      max: function (n, e) {
        return `The field cannot contain more ${e.length} symbols.`
      },
      min: function (n, e) {
        return `The field must contain at least ${e.length} symbols.`
      },
      'max_value': function (n, e) {
        return `Value must not exceed ${e}.`
      },
      'min_value': function (n, e) {
        return `The value must not be less than ${e}.`
      },
      phoneNumber: function (n, e) {
        return "Enter correct phone number."
      },
      passwordMethod: function (n, e) {
        return "Enter a more complex password."
      },
      confirmed: function (n, e) {
        return "Values do not match."
      },
    },
  },
}

export { dictionary }



// WEBPACK FOOTER //
// ./src/js/validation/constants.js